<script setup lang="ts">
import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';
import { computed } from 'vue';

const emits = defineEmits(['update:modelValue']);

const router = useRouter();

const props = defineProps<{
  modelValue: boolean
  isDisabled: boolean
}>()

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
});

function moveDailyReportList() {
  router.push({ name: "DailyReport" })
}
</script>
<template>
  <div
    class="w-100 d-flex justify-content-end mx-auto"
  >
    <v-btn
      class="reset-btn"
      @click="moveDailyReportList"
    >
      {{ i18n.global.t('pages.dailyReports.combineForm.cancel') }}
    </v-btn>
    <v-btn
      class="exec-btn ml-4"
      :disabled="props.isDisabled"
      :style="{
        backgroundColor: props.isDisabled ? '#B3B8BB' : '',
      }"
      @click="modelValue = true"
    >
      {{ i18n.global.t('pages.dailyReports.combineForm.confirm') }}
    </v-btn>
  </div>
</template>
